import { RefCodeService } from './ref-code.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { REF_CODE_TYPE, RefCode, RefCodeKey } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class RefCodeResolverBase implements Resolve<RefCode> {

  constructor(protected service: RefCodeService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<RefCode> {
    const key: RefCodeKey = REF_CODE_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



